import axios from "./request";
import { Log } from "./log";
export const AddPermission = (
  //添加权限
  params
) => {
  const { name, roles } = params;
  const data = new FormData();
  data.append("name", name);
  data.append("power", JSON.stringify(roles));
  Log(`添加了权限,${name}`);
  return axios.post("/add_power", data);
};
export const UpdatePermission = (
  //修改权限
  params
) => {
  const { name, roles, id } = params;
  const data = new FormData();
  data.append("name", name);
  data.append("power", JSON.stringify(roles));
  data.append("id", id);
  data.append("type", 1);
  Log(`更新了权限,${name},id为${id}`);
  return axios.post("/up_power", data);
};
export const DeletePermission = (
  //删除权限
  params
) => {
  const { id } = params;
  const data = new FormData();
  data.append("id", id);
  data.append("type", 2);
  Log(`删除了权限,id为${id}`);
  return axios.post("/up_power", data);
};
export const getPermission = (
  //获取权限列表
  params
) => {
  const { page } = params;
  const data = new FormData();
  data.append("page", page);
  return axios.post("/power_list", data);
};

export const SetBanner = (
  //设置banner
  params
) => {
  const {
    banner,
    sort,
    is_use,
    name,
    sponsor,
    start_time,
    end_time,
    phone,
    content,
    created_id,
    is_function
  } = params;
  const data = new FormData();
  data.append("type", 1);
  data.append("banner", banner[0] ? banner[0].url : "");
  data.append("sort", sort);
  data.append("is_use", is_use);
  data.append("name", name);
  data.append("sponsor", sponsor);
  data.append("start_time", start_time);
  data.append("end_time", end_time);
  data.append("phone", phone);
  data.append("content", content);
  data.append("created_id", created_id);
  data.append("is_function", is_function ? 1 : 0);
  Log(`设置了轮播图`);
  return axios.post("/banner", data);
};
export const GetBanner = (
  params //获取banner
) => {
  const { is_admin, name } = params;
  const data = new FormData();
  data.append("type", "");
  data.append("is_admin", is_admin);
  data.append("name", name || "");
  return axios.post("/banner", data);
};

export const UpdateBanner = (
  //更新banner
  params
) => {
  const {
    id,
    banner,
    sort,
    is_use,
    name,
    sponsor,
    start_time,
    end_time,
    phone,
    content,
    created_id,
    is_function
  } = params;
  const data = new FormData();
  data.append("type", 2);
  data.append("id", id);
  data.append("banner", banner[0] ? banner[0].url : "");
  data.append("sort", sort);
  data.append("is_use", is_use);
  data.append("name", name);
  data.append("sponsor", sponsor);
  data.append("start_time", start_time);
  data.append("end_time", end_time);
  data.append("phone", phone);
  data.append("content", content);
  data.append("created_id", created_id);
  data.append("is_function", is_function ? 1 : 0);
  Log(`更新了轮播图,id为${id}`);
  return axios.post("/banner", data);
};
export const DeleteBanner = (
  params //删除banner
) => {
  const { id } = params;
  const data = new FormData();
  data.append("type", "3");
  data.append("id", id);
  Log(`删除了轮播图,id为${id}`);
  return axios.post("/banner", data);
};
export const showHideBanner = (
  params //显示隐藏banner
) => {
  const { id, is_use } = params;
  const data = new FormData();
  data.append("type", "2");
  data.append("id", id);
  data.append("is_use", is_use);
  Log(`${is_use == 1 ? "显示" : "隐藏"}了轮播图,id为${id}`);
  return axios.post("/banner", data);
};
export const AddInstitution = (
  //添加机构
  params
) => {
  const { name, site, synopsis, logo } = params;
  const data = new FormData();
  data.append("name", name);
  data.append("site", site);
  data.append("synopsis", synopsis);
  data.append("logo", logo);
  Log(`添加了机构${name}`);
  return axios.post("/add_institution", data);
};
export const UpdateInstitution = (
  //修改机构
  params
) => {
  const { name, site, synopsis, logo, id } = params;
  const data = new FormData();
  data.append("name", name);
  data.append("site", site);
  data.append("synopsis", synopsis);
  data.append("logo", logo);
  data.append("id", id);
  data.append("type", 1);
  Log(`更新了机构${name},id为${id}`);
  return axios.post("/up_institution", data);
};
export const DeleteInstitution = (
  //删除机构
  params
) => {
  const { id } = params;
  const data = new FormData();
  data.append("id", id);
  data.append("type", 2);
  Log(`删除了机构,id为${id}`);
  return axios.post("/up_institution", data);
};
export const GetInstitution = (
  //获取机构列表
  params
) => {
  const { page, num } = params;
  const data = new FormData();
  data.append("page", page);
  data.append("num", num || "");
  return axios.post("/institution_list", data);
};

export const AddPerson = (
  //添加人员
  params
) => {
  const {
    name,
    newpassword,
    head_portrait,
    nickname,
    phone,
    role,
    unit,
    power
  } = params;
  const data = new FormData();
  data.append("name", name);
  data.append("password", newpassword);
  data.append(
    "head_portrait",
    head_portrait && head_portrait[0] ? head_portrait[0].url : "/avatar.png"
  );
  data.append("nickname", nickname);
  data.append("phone", phone);
  data.append("role", role);
  data.append("power", power);
  data.append("unit", unit);
  data.append("type", 3);
  Log(`添加了人员${name}`);
  return axios.post("/personal", data);
};
export const EditPerson = (
  //修改人员
  params
) => {
  const {
    id,
    name,
    newpassword,
    head_portrait,
    nickname,
    phone,
    role,
    unit,
    power
  } = params;
  const data = new FormData();
  data.append("id", id);
  data.append("name", name);
  if (newpassword) {
    data.append("password", newpassword);
  }
  data.append(
    "head_portrait",
    head_portrait && head_portrait[0] ? head_portrait[0].url : "/avatar.png"
  );
  data.append("nickname", nickname);
  data.append("phone", phone);
  data.append("role", role);
  data.append("unit", unit);
  data.append("power", power);
  data.append("type", 2);
  Log(`修改了人员${name},id为${id}`);
  return axios.post("/personal", data);
};
export const ShowPerson = (
  //人员列表
  params
) => {
  const { name, page } = params;
  const data = new FormData();
  data.append("page", page);
  data.append("name", name);
  return axios.post("/member_list", data);
};
export const DeletePerson = (
  //删除人员
  params
) => {
  const { id } = params;
  const data = new FormData();
  data.append("id", id);
  Log(`删除了人员,id为${id}`);
  return axios.post("/del_member", data);
};

export const uploadPerson = (
  //上传人员
  params
) => {
  const { file } = params;
  const data = new FormData();
  data.append("file", file);
  Log(`批量上传了人员`);
  return axios.post("/uploading_member", data);
};
export const forbiddenPerson = (
  //启用禁用
  params
) => {
  const { id, forbidden } = params;
  const data = new FormData();
  data.append("id", id);
  data.append("forbidden", forbidden);
  data.append("type", 2);
  Log(`${forbidden ? "禁用" : "启用"}了人员,id为${id}`);
  return axios.post("/personal", data);
};

export const resetPersonPassword = (
  //重置密码
  params
) => {
  const { id } = params;
  const data = new FormData();
  data.append("id", id);
  Log(`批量重置了密码,id为${id}`);
  return axios.post("/reset_password", data);
};



// WEBPACK FOOTER //
// ./src/request/systemSettings.js